/** What a query response reports it could not honour, normalised so an older response reads as "nothing". */

import type { IgnoredFilter, QueryResponse, QueryWarning } from 'src/components/star-grid/api/reportEngineTypes';

export interface QueryNotices {
  readonly unresolvedMembers: readonly string[];
  readonly ignoredFilters: readonly IgnoredFilter[];
  readonly warnings?: readonly QueryWarning[];
}

export const queryNotices = (response: QueryResponse | undefined): QueryNotices => {
  const unresolvedMembers = [...new Set((response?.unresolved_members ?? []).map((member) => String(member ?? '').trim()))].filter(Boolean);
  const seen = new Set<string>();
  const ignoredFilters = (response?.ignored_filters ?? []).filter((entry) => {
    const dimension = String(entry?.dimension ?? '').trim();
    if (!dimension || seen.has(dimension)) return false;
    seen.add(dimension);
    return true;
  });
  const warningKeys = new Set<string>();
  const warnings = (response?.warnings ?? []).filter((entry) => {
    const message = String(entry?.message ?? '').trim();
    const key = `${entry?.code ?? ''}|${entry?.field ?? ''}`;
    if (!message || warningKeys.has(key)) return false;
    warningKeys.add(key);
    return true;
  });
  return { unresolvedMembers, ignoredFilters, warnings };
};
